import { BoltFillIcon, Button } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { overlay } from 'overlay-kit';
import { v4 as uuidv4 } from 'uuid';
import { useOpenWindow } from '@/hooks';
import { DialogBody, DialogFooter, DialogHeader, ResponsiveDialog } from '@/ui_v3';
interface QuotaExceededModalProps {
  onClose: () => void;
}

/**
 * Quota Exceeded Modal Component
 *
 * Displayed when guest users exhaust their daily free AI quiz generation quota.
 * Prompts users to upgrade their plan for unlimited quiz generation.
 *
 * Features:
 * - Title: "무료 생성 횟수를 모두 사용했어요"
 * - Description: Explains daily limit exhaustion and upgrade benefits
 * - CTA: Gradient button with BoltFill icon linking to /pricing
 * - Close button (X) in header
 */
const QuotaExceededModalComponent = ({
  onClose
}: QuotaExceededModalProps) => {
  const {
    t
  } = useTranslation(['common']);
  const openWindow = useOpenWindow();
  const handleUpgradeClick = () => {
    openWindow('/pricing');
    onClose();
  };
  return <ResponsiveDialog onClose={onClose} size="sm" shouldCloseOnDimClick={true} data-sentry-element="ResponsiveDialog" data-sentry-component="QuotaExceededModalComponent" data-sentry-source-file="QuotaExceededModal.tsx">
      <DialogHeader title={t('common:ai.guest.quotaExhausted.title')} hasCloseButton={true} onClose={onClose} data-sentry-element="DialogHeader" data-sentry-source-file="QuotaExceededModal.tsx" />
      <DialogBody className="px-md mobile-lg:px-lg" data-sentry-element="DialogBody" data-sentry-source-file="QuotaExceededModal.tsx">
        <p className="text-body-md-regular text-default">
          {t('common:ai.guest.quotaExhausted.description')}
        </p>
      </DialogBody>
      <DialogFooter data-sentry-element="DialogFooter" data-sentry-source-file="QuotaExceededModal.tsx">
        <Button intent="gradient" variant="contained" size="lg" onClick={handleUpgradeClick} leftSlot={<BoltFillIcon size="sm" />} className="w-full" data-sentry-element="Button" data-sentry-source-file="QuotaExceededModal.tsx">
          {t('common:detail.planPurchase')}
        </Button>
      </DialogFooter>
    </ResponsiveDialog>;
};
export const quotaExceededModalOverlayId = uuidv4();
export const quotaExceededModal = {
  open: () => {
    return overlay.open(({
      unmount
    }) => {
      return <QuotaExceededModalComponent onClose={unmount} />;
    }, {
      overlayId: quotaExceededModalOverlayId
    });
  },
  close: () => {
    overlay.unmount(quotaExceededModalOverlayId);
  }
};